@use "~theme/breakpoints";

.desktopView {
  display: none;

  @include breakpoints.desktop {
    display: block;
    margin-bottom: 68px;
  }
}
